// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__57jNV","modal_open":"Modal_modal_open__Nyov-","modal_content":"Modal_modal_content__SD5yL","modal_content_open":"Modal_modal_content_open__qSDGU"};